<main class="py-36px px-46px bg bg-off-white rounded-12px h-full">
	<header class="mb-24px">
		<div class="flex justify-between items-center">
			<div class="flex">
				<h1 class="mb-0">
					{{ 'REVIEWS.REVIEW_DETAILS' | translate }}
				</h1>
				<app-status
					class="mx-12px"
					[enumData]="ReviewStatusEnum"
					[statusValue]="data?.reviewStatus"
				></app-status>
			</div>
			<div (click)="closeDialog()">
				<img
					class="ml-[100%] cursor-pointer"
					src="assets/images/close-square.svg"
					alt=""
				/>
			</div>
		</div>
	</header>
	<section class="flex gap-[12px] mb-24px">
		<img
			class="max-w-[321px] rounded-[20px]"
			*ngFor="let image of data?.reviewImages"
			[src]="attachmentLink + image"
			alt=""
		/>
	</section>
	<section class="p-16px rounded-12px border-[1px] border-secondry-color-Gray">
		<div class="flex justify-between mb-6px">
			<div class="flex">
				<p class="me-[5px] mb-0 font-DIN-Medium text-font-16 text-dark-grey">
					{{ data?.clientName }}
				</p>

				<img
					class="max-w-[17px]"
					*ngFor="let item of [].constructor(data?.rating)"
					src="./assets/images/star.svg"
					alt=""
				/>
				<span class="mx-[6px]">{{ data?.rating }}</span>
			</div>
			<p class="mb-0">
				{{ data?.reviewDateTime | date : 'dd/MM/yyyy' : 'UTC' }}
			</p>
		</div>
		<p class="text-font-16 text-medium-gray">
			{{ data?.comment }}
		</p>
	</section>
	<section *ngIf="data?.reviewStatus == 1" class="mt-24px">
		<div class="flex flex-col">
			<button
				(click)="changeStatus(2)"
				class="py-16px bg-gradient text-off-white rounded-6px mb-[10px]"
			>
				{{ 'ACTIONS.CONFIRM' | translate }}
			</button>
			<button
				(click)="changeStatus(3)"
				class="py-16px bg-transparent text-dark-grey rounded-6px border-[1px] border-secondry-color-Gray"
			>
				{{ 'ACTIONS.CANCEL' | translate }}
			</button>
		</div>
	</section>
</main>
